import Fuse from 'fuse.js';
import { TrackingEventsEnum } from '@/enums';
import { filterVisibleCategories } from './menu.service.js';
import {
    filterCategoriesByAllergens,
    filterCategoriesByDiet
} from '@/helpers/allergens.js';

const DEFAULT_SEARCH_OPTIONS = {
    keys: [
        {
            name: 'name',
            weight: 3
        },
        {
            name: 'categoryName',
            weight: 2
        },
        {
            name: 'description'
        }
    ]
};

export function createSearchInstance(
    products,
    options = DEFAULT_SEARCH_OPTIONS
) {
    return new Fuse(products, options);
}

export function performSearch(fuseInstance, query, products) {
    const trimmedQuery = query.trim();

    if (trimmedQuery === '') {
        return products.map((item, refIndex) => ({ item, refIndex }));
    }

    return fuseInstance.search(trimmedQuery);
}

export function processSearchResults(
    results,
    categories,
    activeFilterTags = [],
    selectedArea = null,
    allergenFilters = [],
    dietFilters = []
) {
    let processedCategories = [];
    const categoryIds = [];

    for (const result of results) {
        const category = categories.find(
            ({ id }) => id === result.item.categoryId
        );

        if (!categoryIds.includes(result.item.categoryId)) {
            processedCategories.push({ ...category, products: [result.item] });
        } else {
            const existingCategory = processedCategories.find(
                ({ id }) => id === result.item.categoryId
            );

            if (existingCategory) {
                existingCategory.products.push(result.item);
            }
        }

        categoryIds.push(result.item.categoryId);
    }

    if (activeFilterTags?.length > 0) {
        processedCategories = processedCategories
            .map(category => ({
                ...category,
                products: category.products.filter(product =>
                    product.tags?.some(tag => activeFilterTags.includes(tag))
                )
            }))
            .filter(category => category.products.length > 0);
    }

    if (allergenFilters?.length > 0) {
        processedCategories = filterCategoriesByAllergens(
            processedCategories,
            allergenFilters
        );
    }

    if (dietFilters?.length > 0) {
        processedCategories = filterCategoriesByDiet(
            processedCategories,
            dietFilters
        );
    }

    if (selectedArea) {
        processedCategories = filterVisibleCategories(
            processedCategories,
            selectedArea
        );
    }

    return processedCategories;
}

export function trackSearchAnalytics(
    query,
    resultCount,
    analytics,
    delay = 1000
) {
    return setTimeout(() => {
        if (analytics) {
            analytics.track(TrackingEventsEnum.PRODUCTS_SEARCHED, {
                query: query,
                resultCount: resultCount || 0
            });
        }
    }, delay);
}
